import KSelectInputList from "./selectInputList.vue";
export default KSelectInputList;
